export default function FeatureSection() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-12 gap-4">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 tracking-tight max-w-xl">
            What You Can Do With ItaobuySpreadsheet
          </h2>
          <p className="text-sm text-foreground-500 max-w-xs">
            Powerful spreadsheet tools designed for modern online shoppers
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          <div className="lg:col-span-1 bg-background-100 rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20clean%20workspace%20with%20laptop%20displaying%20organized%20product%20grid%20on%20screen%2C%20warm%20natural%20light%2C%20pastel%20cream%20background%2C%20minimal%20desk%20setup%2C%20soft%20shadows%2C%20professional%20and%20airy%20mood&width=600&height=400&seq=feat-search-v9&orientation=landscape"
              alt="Product Search with ItaobuySpreadsheet"
              title="ItaobuySpreadsheet Product Search"
              className="w-full h-48 object-cover"
              loading="lazy"
            />
            <div className="p-6">
              <h3 className="text-lg font-semibold text-foreground-950">Product Search</h3>
              <p className="text-sm text-foreground-600 mt-2 leading-relaxed">
                Find items faster than manual browsing with organized spreadsheet-based product discovery. Sort and filter through thousands of curated listings effortlessly.
              </p>
            </div>
          </div>

          <div className="lg:col-span-1 flex flex-col gap-6">
            <div className="bg-background-100 rounded-2xl p-6 flex-1">
              <h3 className="text-lg font-semibold text-foreground-950">Price Comparison</h3>
              <p className="text-sm text-foreground-600 mt-2 leading-relaxed">
                Save up to 30–60% on sourcing by comparing prices across multiple sources within a single organized spreadsheet view.
              </p>
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20minimal%20product%20price%20comparison%20visual%20with%20warm%20pastel%20background%2C%20organized%20product%20cards%20with%20price%20tags%2C%20soft%20studio%20lighting%2C%20elegant%20arrangement%2C%20no%20harsh%20shadows%2C%20professional%20ecommerce%20aesthetic&width=600&height=400&seq=feat-compare-v9&orientation=landscape"
                alt="Price Comparison on ItaobuySpreadsheet"
                title="ItaobuySpreadsheet Price Comparison"
                className="w-full h-36 object-cover rounded-xl mt-4"
                loading="lazy"
              />
            </div>
            <div className="bg-background-100 rounded-2xl p-6 flex-1">
              <h3 className="text-lg font-semibold text-foreground-950">Spreadsheet Filters</h3>
              <p className="text-sm text-foreground-600 mt-2 leading-relaxed">
                Sort by price, quality rating, popularity, and more. Powerful filtering tools help you narrow down choices in seconds.
              </p>
              <img
                src="https://readdy.ai/api/search-image?query=Minimal%20clean%20interface%20with%20filter%20and%20sort%20options%20displayed%20on%20a%20soft%20cream%20background%2C%20organized%20data%20grid%20layout%2C%20warm%20neutral%20color%20palette%2C%20modern%20UI%20design%20aesthetic%2C%20soft%20lighting%2C%20professional%20look&width=600&height=400&seq=feat-filter-v9&orientation=landscape"
                alt="Spreadsheet Filters on ItaobuySpreadsheet"
                title="ItaobuySpreadsheet Filters"
                className="w-full h-36 object-cover rounded-xl mt-4"
                loading="lazy"
              />
            </div>
          </div>

          <div className="lg:col-span-1 flex flex-col gap-6">
            <div className="bg-background-100 rounded-2xl p-6 flex-1">
              <h3 className="text-lg font-semibold text-foreground-950">Beginner Guides</h3>
              <p className="text-sm text-foreground-600 mt-2 leading-relaxed">
                Step-by-step instructions make it easy for anyone to start using spreadsheet-based shopping tools, even with zero experience.
              </p>
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20minimal%20guide%20or%20tutorial%20layout%20on%20a%20soft%20warm%20pastel%20background%2C%20step%20by%20step%20visual%20with%20simple%20icons%2C%20friendly%20and%20approachable%20design%2C%20natural%20light%2C%20professional%20yet%20inviting%20mood&width=600&height=400&seq=feat-guide-v9&orientation=landscape"
                alt="Beginner Guides for ItaobuySpreadsheet"
                title="ItaobuySpreadsheet Beginner Guides"
                className="w-full h-36 object-cover rounded-xl mt-4"
                loading="lazy"
              />
            </div>
            <div className="bg-background-100 rounded-2xl p-6 flex-1">
              <h3 className="text-lg font-semibold text-foreground-950">Updated Lists</h3>
              <p className="text-sm text-foreground-600 mt-2 leading-relaxed">
                Always fresh product data with regularly updated curated lists across all 14 shopping categories.
              </p>
              <img
                src="https://readdy.ai/api/search-image?query=Organized%20product%20list%20or%20catalog%20display%20on%20a%20clean%20warm%20cream%20background%2C%20fresh%20and%20modern%20layout%2C%20soft%20natural%20lighting%2C%20minimal%20design%2C%20elegant%20product%20photography%20style&width=600&height=400&seq=feat-update-v9&orientation=landscape"
                alt="Updated Product Lists on ItaobuySpreadsheet"
                title="ItaobuySpreadsheet Updated Lists"
                className="w-full h-36 object-cover rounded-xl mt-4"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}